<template>

  <div class="einvoice-detail-toolbar d-flex align-items-center justify-content-between w-100">
     <!-- Left: Back + Invoice Info -->
    <div class="d-flex align-items-center">
       <b-button
        variant="link"
        size="sm"
        class="font-weight-bold text-muted p-0 mr-3"
        @click="$emit('go-back')"
        > <i class="fas fa-arrow-left mr-1"></i> Quay lại </b-button
      >
      <h4 class="mb-0 font-weight-bolder mr-3"> {{ invoiceNo || '--' }} </h4>
       <EInvoiceStatusBadge
        :status="status"
        class="mr-3"
      />
    </div>
     <!-- Right: Action buttons with clear hierarchy -->
    <div class="d-flex align-items-center">
       <!-- PDF Download - Always visible when available (P0: surfaced from dropdown) --> <b-button
        v-if="canDownloadPdf"
        variant="outline-primary"
        size="sm"
        class="font-weight-bolder mr-2"
        @click="$emit('download-pdf')"
        :disabled="pdfButtonDisabled"
        :title="pdfButtonTitle"
      > <i class="fas fa-file-pdf mr-1"></i> {{ pdfButtonLabel }} </b-button
      >
      <!-- Draft actions from backend allowedActions -->
      <!-- TODO: Ẩn chức năng này -->
      <!-- <b-button
        v-if="canEdit"
        variant="outline-secondary"
        size="sm"
        class="font-weight-bolder mr-2"
        @click="$emit('edit')"
        :disabled="isLoading"
        > <i class="fas fa-pen mr-1"></i> Chỉnh sửa
      </b-button>
      <b-button
        v-if="canValidateDraft"
        variant="outline-info"
        size="sm"
        class="font-weight-bolder mr-2"
        @click="$emit('validate-draft')"
        :disabled="isLoading"
        > <i class="fas fa-check-circle mr-1"></i> Kiểm tra dữ liệu
      </b-button> -->
      <b-button
        v-if="canPreviewDraft"
        variant="outline-primary"
        size="sm"
        class="font-weight-bolder mr-2"
        @click="$emit('preview-draft')"
        :disabled="isLoading"
        > <i class="fas fa-eye mr-1"></i> Xem trước PDF
      </b-button>
      <b-button
        v-if="canDeleteDraft"
        variant="outline-danger"
        size="sm"
        class="font-weight-bolder mr-2"
        @click="$emit('delete-draft')"
        :disabled="isLoading"
        > <i class="fas fa-trash-alt mr-2"></i> Xoá nháp
      </b-button>
      <b-button
        v-if="canIssue"
        variant="primary"
        size="sm"
        class="font-weight-bolder mr-2"
        @click="$emit('issue')"
        :disabled="isLoading || hasBlockingErrors"
        :title="issueDisabledReason"
        > <i class="fas fa-paper-plane mr-1"></i> Phát hành
      </b-button>

      <!-- TODO: Ẩn chức năng này -->
     <!-- <b-dropdown
        v-if="canIssue"
        split
        size="sm"
        variant="primary"
        class="mr-2"
        right
        @click="$emit('issue')"
        :disabled="isLoading || hasBlockingErrors"
        :title="issueDisabledReason"
        > <template #button-content> <i class="fas fa-paper-plane mr-1"></i> Phát hành </template>
        <b-dropdown-item
          v-if="canRefreshTax"
          @click="$emit('refresh-tax')"
          > <i class="fas fa-sync-alt mr-2 text-info"></i> Kiểm tra CQT </b-dropdown-item
        > <b-dropdown-item
          v-if="canResendEmail"
          @click="$emit('resend-email')"
          > <i class="fas fa-envelope mr-2 text-info"></i> Gửi lại email </b-dropdown-item
        > <b-dropdown-divider v-if="canShowCorrections"></b-dropdown-divider>
        <b-dropdown-group
          v-if="canShowCorrections"
          header="Xử lý sai sót"
          > <b-dropdown-item
            v-if="canAdjust"
            @click="$emit('adjust')"
            > <i class="fas fa-edit mr-2 text-info"></i> Điều chỉnh </b-dropdown-item
          > <b-dropdown-item
            v-if="canReplace"
            @click="$emit('replace')"
            > <i class="fas fa-exchange-alt mr-2 text-warning"></i> Thay thế </b-dropdown-item
          > </b-dropdown-group
        ><template
          v-if="canCancel"
          > <b-dropdown-divider></b-dropdown-divider> <b-dropdown-item
            @click="$emit('cancel')"
            class="dropdown-item--danger"
            > <i class="fas fa-ban mr-2"></i> Huỷ hoá đơn </b-dropdown-item
          > </template
        >
        <template v-if="canDeleteDraft"
          > <b-dropdown-divider></b-dropdown-divider> <b-dropdown-item
            @click="$emit('delete-draft')"
            class="dropdown-item--danger"
            > <i class="fas fa-trash-alt mr-2"></i> Xoá nháp </b-dropdown-item
          > </template
        >
        </b-dropdown
      >
      <b-dropdown
        v-else-if="hasSecondaryActions"
        size="sm"
        variant="outline-secondary"
        class="mr-2"
        right
        > <template #button-content> <i class="fas fa-ellipsis-v"></i> </template> <b-dropdown-item
          v-if="canRefreshTax"
          @click="$emit('refresh-tax')"
          > <i class="fas fa-sync-alt mr-2 text-info"></i> Kiểm tra CQT </b-dropdown-item
        > <b-dropdown-item
          v-if="canResendEmail"
          @click="$emit('resend-email')"
          > <i class="fas fa-envelope mr-2 text-info"></i> Gửi lại email </b-dropdown-item
        > <b-dropdown-divider v-if="canShowCorrections"></b-dropdown-divider>
        <b-dropdown-group
          v-if="canShowCorrections"
          header="Xử lý sai sót"
          > <b-dropdown-item
            v-if="canAdjust"
            @click="$emit('adjust')"
            > <i class="fas fa-edit mr-2 text-info"></i> Điều chỉnh </b-dropdown-item
          > <b-dropdown-item
            v-if="canReplace"
            @click="$emit('replace')"
            > <i class="fas fa-exchange-alt mr-2 text-warning"></i> Thay thế </b-dropdown-item
          > </b-dropdown-group
        > <template v-if="canCancel"
          > <b-dropdown-divider></b-dropdown-divider> <b-dropdown-item
            @click="$emit('cancel')"
            class="dropdown-item--danger"
            > <i class="fas fa-ban mr-2"></i> Huỷ hoá đơn </b-dropdown-item
          > </template
        > <template v-if="canDeleteDraft"
          > <b-dropdown-divider></b-dropdown-divider> <b-dropdown-item
            @click="$emit('delete-draft')"
            class="dropdown-item--danger"
            > <i class="fas fa-trash-alt mr-2"></i> Xoá nháp </b-dropdown-item
          > </template
        > </b-dropdown
      > -->
    </div>

  </div>

</template>

<script>
  import EInvoiceStatusBadge from './EInvoiceStatusBadge.vue'

  export default {
    name: 'EInvoiceDetailToolbar',
    components: {
      EInvoiceStatusBadge,
    },
    props: {
      invoiceNo: {
        type: String,
        default: null,
      },
      status: {
        type: Number,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      hasBlockingErrors: {
        type: Boolean,
        default: false,
      },
      issueDisabledReason: {
        type: String,
        default: '',
      },
      // Action visibility flags
      canEdit: {
        type: Boolean,
        default: false,
      },
      canIssue: {
        type: Boolean,
        default: false,
      },
      canDownloadPdf: {
        type: Boolean,
        default: false,
      },
      canValidateDraft: {
        type: Boolean,
        default: false,
      },
      canPreviewDraft: {
        type: Boolean,
        default: false,
      },
      pdfCooldownActive: {
        type: Boolean,
        default: false,
      },
      pdfCooldownSeconds: {
        type: Number,
        default: 0,
      },
      canRefreshTax: {
        type: Boolean,
        default: false,
      },
      canResendEmail: {
        type: Boolean,
        default: false,
      },
      canAdjust: {
        type: Boolean,
        default: false,
      },
      canReplace: {
        type: Boolean,
        default: false,
      },
      canCancel: {
        type: Boolean,
        default: false,
      },
      canDeleteDraft: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      pdfButtonDisabled() {
        return this.isLoading || this.pdfCooldownActive
      },
      pdfButtonTitle() {
        if (!this.pdfCooldownActive) return ''
        const remainingSeconds = Math.max(1, Number(this.pdfCooldownSeconds) || 0)
        return `PDF đang cooldown. Thử lại sau ${remainingSeconds} giây.`
      },
      pdfButtonLabel() {
        if (!this.pdfCooldownActive) return 'Xem PDF'
        const remainingSeconds = Math.max(1, Number(this.pdfCooldownSeconds) || 0)
        return `Xem PDF (${remainingSeconds}s)`
      },
      canShowCorrections() {
        return this.canAdjust || this.canReplace
      },
      hasSecondaryActions() {
        return (
          this.canRefreshTax ||
          this.canResendEmail ||
          this.canAdjust ||
          this.canReplace ||
          this.canCancel ||
          this.canDeleteDraft
        )
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '../einvoice.scss';

.einvoice-detail-toolbar {
  padding: 0.5rem 0;

  // Back button hover
  .btn-link {
    transition: color 0.15s ease, transform 0.15s ease;
    text-decoration: none;

    &:hover {
      color: $einvoice-status-issued !important;
      transform: translateX(-2px);
    }
  }

  // Button press feedback
  .btn {
    transition: all 0.15s ease;

    &:active {
      transform: scale(0.97);
    }
  }
}
</style>
